import axios from "axios";
import * as Types from "../../../store/actions/types";
import { manageError } from "../../../store/utils/axiosResponseError";
import ToastManager from "../../default/popup/alert/apiNotification";

export const retrieveCardsAction = (data) => async (dispatch) => {
	let responseData;
	const { page } = data;
	dispatch({
		type: Types.CARD_IS_LOADING,
		payload: true,
	});

	await axios
		.post(`/card/list`, {...data})
		.then((res) => {
			responseData = res.data;
			dispatch({
				type: Types.CARD_RETRIEVE,
				payload: {
					response: responseData,
					page: page,
					error: {},
				},
			});
		})
		.catch((error) => {
			manageError(error);
		});
	return responseData;
};

export const CardsCategoryAction = (data) => async (dispatch) => {
	let responseData;
	const { page } = data;
	dispatch({
		type: Types.CARD_IS_LOADING,
		payload: true,
	});

	await axios
		.get(`essential/group?type=cards`, {params: data})
		.then((res) => {
			responseData = res.data;
			dispatch({
				type: Types.CARD_CATEGORY_RETRIEVE,
				payload: {
					response: responseData,
					page: page,
					error: {},
				},
			});
		})
		.catch((error) => {
			manageError(error);
		});
	return responseData;
};
export const UpdateCardAction = (data, id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Updating...');
    try {

        const response = await axios.post(`/card/update`, {...data});
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Card updated successfully!');
            dispatch({ 
                type: Types.CARD_SETTINGS_UPDATE, 
                payload: {
                    cardId: id,
					data: response.data
                }
            });
        }

    } catch(err) {
        let errorMsg = Object.values(Error.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to update card.');
    }
};
export const DeleteCardAction = (id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Deleting...');
    try {

        const response = await axios.post(`/card/delete`, {
            cardID: id
        });
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Card deleted successfully!');
            dispatch({ 
                type: Types.CARD_DELETE_ITEM, 
                payload: {
                    id: id
                }
            });
        }

    } catch(err) {
        let errorMsg = Object.values(Error.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to delete card.');
    }
};

